export default __webpack_public_path__ + "static/media/rain.cdc4e810.mp4";